import React, { createContext, useState } from 'react'

export const BreadCrumbContext = createContext({ buttons: [], crumbs: [] })

const Context = ({ children }) => {
    const [buttons, setCrumbButtons] = useState<any>([])
    const [crumbs, setCrumbs] = useState<any>([])

    const ctx: any = {
        buttons,
        crumbs,
        setCrumbButtons,
        setCrumbs,
    }
    return <BreadCrumbContext.Provider value={ctx}>{children}</BreadCrumbContext.Provider>
}

export default Context
